import axios from "axios";
import beveatApiResourceOwner from "../../api/resource_owner_beveat_api.js";
import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DeveloperProjectCard from "../components/developer_project_card.jsx";
import ProgressSpinner from "../../views/components/progress_spinner.jsx";
import { projectCurrentTabContext, projectTabContext } from "../../views/project/context/developer_project_context.jsx";
import ProjectTab from "../../views/project/components/developer_project_tab.jsx";
import { urls, commonConfigs } from "../../../config.js";
import ComingSoonModal from "../../views/components/coming_soon_modal.jsx";
import { DEVELOPER_PROJ_TABLE_SYSCODE } from "../../constants/developer_proj_table_syscode.jsx";
import { INVOICE_PLAN_SYSCODE, InvoicePlanSyscodeString } from "../../constants/invoice_plan_syscode.jsx";
import { INVOICE_SYSCODE } from "../../constants/invoice_syscode.jsx";

const ProjectLayout = () => {
  const location = useLocation();
  const { currentTab, setTab } = useContext(projectCurrentTabContext);
  const { tabs } = useContext(projectTabContext);
  const [isOpen, setOpen] = useState(false);
  const [load, setLoad] = useState(true);
  const [stagingData, setStagingData] = useState(null);
  const [productionData, setProductionData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  // Mobile detection state
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const ssoId = localStorage.getItem("ssoId");

  const getAllStagingDeveloperProjectsUrl =
    urls.resourceOwnerUrl +
    commonConfigs.apiUrls.GetAllDeveloperProjects(ssoId, DEVELOPER_PROJ_TABLE_SYSCODE.STAGING);
  const getAllProductionDeveloperProjectsUrl =
    urls.resourceOwnerUrl +
    commonConfigs.apiUrls.GetAllDeveloperProjects(ssoId, DEVELOPER_PROJ_TABLE_SYSCODE.PRODUCTION);
  const presetOptions = { environment: { value: "1", label: "Production" } };

  // Mobile detection useEffect
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // auto Tab switch on page load
  useEffect(() => {
    const Tab = tabs.find((tab) => tab.name === InvoicePlanSyscodeString[location.state?.invoicePlanSyscode]);
    if (Tab) {
      setTab(Tab);
    }
  }, [location.state, setTab, tabs]);

  const handleNavigateToPricingPlan = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    navigate("/pricing-plans", {
      state: {
        invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Staging,
        invoiceSyscode: INVOICE_SYSCODE.Certification,
      }
    });
  };

  const handleNavigateToProdPricingPlan = (event) => {
    event.preventDefault(); // Prevent default anchor behavior
    navigate("/pricing-plans", {
      state: {
        invoicePlanSyscode: INVOICE_PLAN_SYSCODE.Production,
        invoiceSyscode: INVOICE_SYSCODE.Project,
      }
    });
  };

  async function getStagingDeveloperProjects() {
    await beveatApiResourceOwner
      .get(getAllStagingDeveloperProjectsUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        // console.log(res.data.result.data);
        setStagingData(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getProductionDeveloperProjects() {
    await beveatApiResourceOwner
      .get(getAllProductionDeveloperProjectsUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        // console.log(res.data.result.data);
        setProductionData(res.data.result.data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getStagingDeveloperProjects();
    getProductionDeveloperProjects();
  }, []);

  const onHandleGetStarted = () => {
    setOpen(true);
    // const disableButton = productionData.some(project => project.developer_proj_agreement !== 1);
    // if (disableButton) {
    // setIsDisabled(disableButton);
    // alert('You have not signed the agreement!');
    // } else {
    navigate('/projects/create', {
      // state: { presetEnvironment: { value: "1", label: "Production" }, isProd: 1, presetOptions: { invoicePlanSyscode: 3 } },
      state: { presetEnvironment: { value: "0", label: "Staging" }, isProd: 0, presetOptions: { invoicePlanSyscode: 2 } },
    })
    // }
  };

  if (!load) {
    return (
      <div style={{ width: "100%" }}>
        <div className={`mt-4 ${isMobile ? 'px-4 space-y-4' : 'desktop:space-x-8 mobile:pt-2 mobile:pb-4 mobile:space-x-2'}`}>
          {/* Mobile-responsive button for 'Create Project' */}
          <button
            type="button"
            onClick={onHandleGetStarted}
            className={`hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2.5 px-14 rounded-full ${isMobile
              ? 'w-full text-center mb-4'
              : 'mr-10'
              }`}
            style={{
              float: isMobile ? "none" : "right",
              visibility:
                // currentTab.name === "Production" ? "visible" : "hidden",
                currentTab.name === "Staging" ? "visible" : "hidden",
            }}
          >
            Create New Project
          </button>

          {isOpen && <ComingSoonModal setOpenModal={setOpen} comingSoonDate={"End May"} />}
          <div>
            <div
              className={`flex-1 min-w-0 ${isMobile ? 'pt-2' : 'mobile:pt-4 mobile: ml-2'}`}
              style={{ marginBottom: isMobile ? "0" : "-20px" }}
            >
              <ProjectTab />
            </div>
            {currentTab.name == "Staging" && (
              <>
                {stagingData != null ? (
                  <>
                    {stagingData.length > 0 ? (
                      <div
                        className={`mt-10 flex flex-grow gap-x-2 ${isMobile ? 'px-2' : 'justify-end pr-10'}`}
                        style={{
                          display: "grid",
                          gridTemplateColumns: isMobile ? "1fr" : "2fr 2fr 2fr",
                          gap: isMobile ? "16px" : "8px",
                        }}
                      >
                        {stagingData.map((item, index) => (
                          <DeveloperProjectCard key={index} data={item} invoicePlanSyscode={INVOICE_PLAN_SYSCODE.Staging} />
                        ))}
                      </div>
                    ) : (
                      <>
                        <div className={`min-h-screen pt-16 pb-12 flex flex-col ${isMobile ? 'px-4' : ''}`}>
                          <div className="py-16">
                            <div className="text-center">
                              <h1 className={`mt-2 font-extrabold text-gray-900 tracking-tight ${isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                                }`}>
                                You don't have any active projects yet!
                              </h1>
                            </div>
                            <div className="mt-6">
                              <Link
                                to="#"
                                onClick={handleNavigateToPricingPlan}
                                className={`text-base font-medium text-gray-400 hover:text-gray-500 ${isMobile ? 'text-lg block text-center' : 'text-xl'
                                  }`}
                              >
                                To get started, check out our Pricing Plans and
                                create your first project!
                                <span aria-hidden="true"> &rarr;</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div className="w-screen h-screen flex flex-wrap flex-row place-items-center">
                    <div className="flex place-content-center w-full">
                      <ProgressSpinner className={isMobile ? "w-12 h-12" : "w-20 h-20"} />
                    </div>
                  </div>
                )}
              </>
            )}
            {currentTab.name == "Production" && (
              <>
                {productionData != null ? (
                  <>
                    {productionData.length > 0 ? (
                      <div
                        className={`mt-10 flex flex-grow gap-x-2 ${isMobile ? 'px-2' : 'justify-end pr-10'}`}
                        style={{
                          display: "grid",
                          gridTemplateColumns: isMobile ? "1fr" : "2fr 2fr 2fr",
                          gap: isMobile ? "16px" : "8px",
                        }}
                      >
                        {productionData.map((item, index) => (
                          <DeveloperProjectCard key={index} data={item} invoicePlanSyscode={INVOICE_PLAN_SYSCODE.Production} />
                        ))}
                      </div>
                    ) : (
                      <>
                        <div className={`min-h-screen pt-16 pb-12 flex flex-col ${isMobile ? 'px-4' : ''}`}>
                          <div className="py-16">
                            <div className="text-center">
                              <h1 className={`mt-2 font-extrabold text-gray-900 tracking-tight ${isMobile ? 'text-2xl' : 'text-4xl sm:text-5xl'
                                }`}>
                                You don't have any production projects yet!
                              </h1>
                            </div>
                            <div className="mt-6">
                              <Link
                                to="#"
                                onClick={handleNavigateToProdPricingPlan}
                                className={`text-base font-medium text-gray-400 hover:text-gray-500 ${isMobile ? 'text-lg block text-center' : 'text-xl'
                                  }`}
                              >
                                To get started, check out our Pricing Plans and
                                create your first project!
                                <span aria-hidden="true"> &rarr;</span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div className="w-screen h-screen flex flex-wrap flex-row place-items-center">
                    <div className="flex place-content-center w-full">
                      <ProgressSpinner className={isMobile ? "w-12 h-12" : "w-20 h-20"} />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default ProjectLayout;